import React, { useState } from "react";
import { PrimaryButton } from "../common/PrimaryButton";

export const Maintenance = ({ handleClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 text-gray-500">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={() => handleClose()}
      ></div>
      <div className="px-6 bg-white rounded-3xl relative py-6 mx-4 w-500">
        <div className="w-40 h-12 mx-auto">
          <div
            className="logo h-full w-full "
            style={{ backgroundPositionY: "center" }}
          />
        </div>
        <div className="text-bold text-lg mt-6">System Maintenance</div>
        <div className="my-4">We're giving this feature a little extra polish, but it'll be back better than ever soon!</div>
        <div>
          <PrimaryButton
            title={"Ok"}
            isLoading={false}
            onClick={() => {
              handleClose();
            }}
          />
        </div>
      </div>
    </div>
  );
};
